import ActiveAptBroadcaster from "./Broadcasters/ActiveAptBroadcaster"
import ActiveBlockBroadcaster from "./Broadcasters/ActiveBlockBroadcaster"
import ActiveFloorBroadcaster from "./Broadcasters/ActiveFloorBroadcaster"
import ApartmentFinderBroadcaster from "./Broadcasters/ApartmentFinderBroadcaster"
import CameraPosBroadcaster from "./Broadcasters/CameraPosBroadcaster.js"
import FavouritesBroadcaster from "./Broadcasters/FavouritesBroadcaster"
import FilterBroadcaster from "./Broadcasters/FilterBroadcaster"
// import LoadingBroadcaster from "./Broadcasters/LoadingBroadcaster"
import MapBroadcaster from "./Broadcasters/MapBroadcaster"
import PoiBroadcaster from "./Broadcasters/PoiBroadcaster"
import ThreeSixtyBroadcaster from "./Broadcasters/ThreeSixtyBroadcaster"
import TwoDBroadcaster from "./Broadcasters/TwoDBroadcaster"

function Broadcasters() {
  return (
    <>
      <ActiveAptBroadcaster />
      <PoiBroadcaster />
      <FavouritesBroadcaster />
      <CameraPosBroadcaster />
      <ActiveBlockBroadcaster />
      <ApartmentFinderBroadcaster />
      <ActiveFloorBroadcaster />
      <FilterBroadcaster />
      <ThreeSixtyBroadcaster />
      <TwoDBroadcaster />
      {/* <LoadingBroadcaster /> */}
      <MapBroadcaster />
    </>
  )
}

export default Broadcasters
